// extracted by mini-css-extract-plugin
export default {"indicator":"ClearIndicator-module__indicator__HjcVf","icon":"ClearIndicator-module__icon__KPrLH"};